module.exports = __webpack_public_path__ + "static/media/service_icon_03.54ac8020.webp";